import { gql } from '@apollo/client';
import { timeColumns } from '../../utils/columns';
import { metricsQueryString } from '../../utils/utils';
import ResourcesTable from './ResourcesTable';

const COLS = [
  {
    accessor: 'name',
    displayString: 'Name',
  },
  {
    accessor: 'pricePerUnit',
    displayString: 'Price per Hour',
  },
  ...timeColumns,
];

export const RawLaborPricingsQuery = gql`
  query RawLaborPricing($farmId: ID!) {
    rawLabor(farmId: $farmId) {
      id
      ${metricsQueryString(COLS)}
    }
  }
`;

const LaborTable = ({ LaborQuery }) => {
  return <ResourcesTable query={LaborQuery} cols={COLS} title="Labor" />;
};

export const FarmLaborTable = () => (
  <LaborTable LaborQuery={RawLaborPricingsQuery} />
);
